function roundToTwoDecimalsIfNeeded(num) {
  // Convert the number to a string to easily check decimal places
  const numStr = String(num);

  // Check if there's a decimal point and if there are more than 2 digits after it
  const decimalIndex = numStr.indexOf('.');
  if (decimalIndex !== -1 && numStr.length - 1 - decimalIndex > 2) {
    // If more than 2 decimal places, round using Math.round
    return Math.round(num * 100) / 100;
  } else {
    // Otherwise, return the original number
    return num;
  }
}

export default roundToTwoDecimalsIfNeeded;
